<template>
    <main :class="[isLight ? 'lightmode' : 'darkmode']">
        <h1>Timezone converter</h1>
        <form @submit.prevent="calculate" :class="[isLight ? 'lightmode' : 'darkmode']">
            <label id="h24-check"><input type="checkbox" v-model="is24Hour"/>24-hour</label>
            <div class="time-selection-div" id="hour-select-div" :class="[isLight ? 'lightmode' : 'darkmode']">
                <label for="hours">Hour</label>
                <select id="hours" :class="[isLight ? 'lightmode' : 'darkmode']" v-model="hour">
                    <option value="0" v-if="is24Hour">00</option>
                    <option value="1">01</option>
                    <option value="2">02</option>
                    <option value="3">03</option>
                    <option value="4">04</option>
                    <option value="5">05</option>
                    <option value="6">06</option>
                    <option value="7">07</option>
                    <option value="8">08</option>
                    <option value="9">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13" v-if="is24Hour">13</option>
                    <option value="14" v-if="is24Hour">14</option>
                    <option value="15" v-if="is24Hour">15</option>
                    <option value="16" v-if="is24Hour">16</option>
                    <option value="17" v-if="is24Hour">17</option>
                    <option value="18" v-if="is24Hour">18</option>
                    <option value="19" v-if="is24Hour">19</option>
                    <option value="20" v-if="is24Hour">20</option>
                    <option value="21" v-if="is24Hour">21</option>
                    <option value="22" v-if="is24Hour">22</option>
                    <option value="23" v-if="is24Hour">23</option>
                </select>
            </div>
            <div class="time-selection-div" id="minute-select-div" :class="[isLight ? 'lightmode' : 'darkmode']">
                <label for="minutes">Minute</label>
                <select id="minutes" :class="[isLight ? 'lightmode' : 'darkmode']" v-model="min">
                    <option value="0">00</option>
                    <option value="1">01</option>
                    <option value="2">02</option>
                    <option value="3">03</option>
                    <option value="4">04</option>
                    <option value="5">05</option>
                    <option value="6">06</option>
                    <option value="7">07</option>
                    <option value="8">08</option>
                    <option value="9">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                    <option value="32">32</option>
                    <option value="33">33</option>
                    <option value="34">34</option>
                    <option value="35">35</option>
                    <option value="36">36</option>
                    <option value="37">37</option>
                    <option value="38">38</option>
                    <option value="39">39</option>
                    <option value="40">40</option>
                    <option value="41">41</option>
                    <option value="42">42</option>
                    <option value="43">43</option>
                    <option value="44">44</option>
                    <option value="45">45</option>
                    <option value="46">46</option>
                    <option value="47">47</option>
                    <option value="48">48</option>
                    <option value="49">49</option>
                    <option value="50">50</option>
                    <option value="51">51</option>
                    <option value="52">52</option>
                    <option value="53">53</option>
                    <option value="54">54</option>
                    <option value="55">55</option>
                    <option value="56">56</option>
                    <option value="57">57</option>
                    <option value="58">58</option>
                    <option value="59">59</option>
                </select>
            </div>
            <div class="time-selection-div" id="second-select-div" :class="[isLight ? 'lightmode' : 'darkmode']">
                <label for="seconds">Second</label>
                <select id="seconds" :class="[isLight ? 'lightmode' : 'darkmode']" v-model="sec">
                    <option value="0">00</option>
                    <option value="1">01</option>
                    <option value="2">02</option>
                    <option value="3">03</option>
                    <option value="4">04</option>
                    <option value="5">05</option>
                    <option value="6">06</option>
                    <option value="7">07</option>
                    <option value="8">08</option>
                    <option value="9">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                    <option value="32">32</option>
                    <option value="33">33</option>
                    <option value="34">34</option>
                    <option value="35">35</option>
                    <option value="36">36</option>
                    <option value="37">37</option>
                    <option value="38">38</option>
                    <option value="39">39</option>
                    <option value="40">40</option>
                    <option value="41">41</option>
                    <option value="42">42</option>
                    <option value="43">43</option>
                    <option value="44">44</option>
                    <option value="45">45</option>
                    <option value="46">46</option>
                    <option value="47">47</option>
                    <option value="48">48</option>
                    <option value="49">49</option>
                    <option value="50">50</option>
                    <option value="51">51</option>
                    <option value="52">52</option>
                    <option value="53">53</option>
                    <option value="54">54</option>
                    <option value="55">55</option>
                    <option value="56">56</option>
                    <option value="57">57</option>
                    <option value="58">58</option>
                    <option value="59">59</option>
                </select>
            </div>
            <div class="time-selection-div" id="h24-select-div">
                <label :class="[isLight ? 'lightmode' : 'darkmode']">24</label>
                <select v-if="!is24Hour" :class="[isLight ? 'lightmode' : 'darkmode']" v-model="AMPMToggle">
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                </select>
            </div>
            <p id="from-lbl">From</p><p id="to-lbl">To</p>
            <div class="timezone-selection" :class="[isLight ? 'lightmode' : 'darkmode']" id="from-select" @click="openFromMenu">
                <p class="timezone-cities">{{ timezoneCities[timezoneFromIndex] }}</p>
                <p class="timezone-names">{{ timezoneNames[timezoneFromIndex] }}</p>
            </div>
            <div class="timezone-selection" :class="[isLight ? 'lightmode' : 'darkmode']" id="to-select" @click="openToMenu">
                <p class="timezone-cities">{{ timezoneCities[timezoneToIndex] }}</p>
                <p class="timezone-names">{{ timezoneNames[timezoneToIndex] }}</p>
            </div>
            <button :class="[isLight ? 'lightmode' : 'darkmode']" type="submit">Convert</button>
            <fieldset>
                <legend>Result</legend>
                <output :class="[formSubmitted ? '' : 'not-submitted',isLight ? 'lightmode' : 'darkmode']">{{ resultLbl }}</output>
            </fieldset>
        </form>
    </main>
</template>

<script setup>
    import { defineProps,toRef,ref,computed,onMounted,defineEmits,watch } from 'vue';
    const timeOfDay = ref(new Date());

    const props = defineProps({
        darkMode:Boolean,
        timezoneFrom:Number,
        timezoneTo:Number
    });

    const emit = defineEmits(['open-timezone-menu','set-timezone-index']);

    const openFromMenu = () =>
    {
        emit('open-timezone-menu',timezoneNames.value,timezoneCities.value,true,false);
    }

    const openToMenu = () =>
    {
        var timezoneToNames = [];
        var timezoneToCities = [];

        if(timezoneFromIndex.value < 35)
        {
            for(let i = 0; i < 35; i++)
            {
                timezoneToCities.push(timezoneCities.value[i]);
                timezoneToNames.push(timezoneNames.value[i]);
            }
        }

        else
        {
            for(let i = 35; i < timezoneCities.value.length; i++)
            {
                timezoneToCities.push(timezoneCities.value[i]);
                timezoneToNames.push(timezoneNames.value[i]);
            }
        }

        emit('open-timezone-menu',timezoneToNames,timezoneToCities,false,true);
    }

    var isLight = toRef(props,"darkMode");
    var is24Hour = ref(false);
    var AMPMToggle = ref("AM");

    watch(is24Hour, (newVal) => 
    {
        if (newVal) 
        {
            // Converting from 12h to 24h
            let h = parseInt(hour.value);
            
            if (AMPMToggle.value === 'PM' && h < 12) {
            hour.value = h + 12;
            } else if (AMPMToggle.value === 'AM' && h === 12) {
            hour.value = 0;
            } else {
            hour.value = h;
            }
        } 
        
        else 
        {
            // Converting from 24h to 12h
            let h = parseInt(hour.value);
            
            if (h === 0) {
            hour.value = 12;
            AMPMToggle.value = 'AM';
            } else if (h === 12) {
            hour.value = 12;
            AMPMToggle.value = 'PM';
            } else if (h > 12) {
            hour.value = h - 12;
            AMPMToggle.value = 'PM';
            } else {
            hour.value = h;
            AMPMToggle.value = 'AM';
            }
        }
    });

    var hourVal = computed(() => timeOfDay.value.getHours());
    var minVal = computed(() => timeOfDay.value.getMinutes());
    var secVal = computed(() => timeOfDay.value.getSeconds());

    var hourComp = computed(() => 
    {
        if (is24Hour.value) return hourVal.value;
        if (hourVal.value === 0 || hourVal.value === 12) return 12;
        return hourVal.value > 12 ? hourVal.value - 12 : hourVal.value;
    });

    var hour = ref(hourComp.value);
    var min = ref(minVal.value);
    var sec = ref(secVal.value);

    var timezoneFromIndex = toRef(props,'timezoneFrom');
    var timezoneToIndex = toRef(props,'timezoneTo');
    
    var formSubmitted = ref(false);
    var resultLbl = ref("Result");

    const isDSTOn = () => 
    {
        const date = new Date();
        const jan = new Date(date.getFullYear(), 0, 1);  // January 1st (likely not DST)
        const jul = new Date(date.getFullYear(), 6, 1);  // July 1st (likely DST if applicable)
        const standardOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

        return date.getTimezoneOffset() < standardOffset;
    }

    const timezoneCities = ref(["Baker Island,US Minority Outlying Islands",
                                "Alofi,Niue; Midway,US Minority Outlying Islands",
                                "Honolulu,Hawaii; Papeete,French Polynesia",
                                "Anchorage,Alaska","Los Angeles,USA; Seattle,USA; Vancouver,Canada",
                                "Denver,USA; Edmonton,Canada; Hermosillo,Mexico; Phoenix,USA",
                                "Easter Island,Chile; Houston,USA; Mexico City,Mexico; Minneapolis,USA",
                                "Bogota,Colombia; Miami,USA; New York City,USA; Toronto,Canada",
                                "Caracas,Venezuela; Halifax,Canada; La Paz,Bolivia; Santiago,Chile",
                                "St.John’s,Canada","Buenos Aires,Argentina; Rio de Janeiro,Brazil",
                                "King Edward Point; Nuuk,Greenland","Praia,Cape Verde",
                                "Casablanca,Morocco; Lisbon,Portugal; London,UK; Reykjavik,Iceland",
                                "Lagos,Nigeria; Luanda,Angola; Paris,France; Rome,Italy",
                                "Bucharest,Romania; Cairo,Egypt; Helsinki,Finland; Johannesburg,South Africa",
                                "Addis Ababa,Ethiopia; Baghdad,Iraq; Moscow,Russia; Riyadh,Saudi Arabia",
                                "Tehran,Iran",
                                "Abu Dhabi,UAE; Samara,Russia; Victoria,Seychelles; Yerevan,Armenia",
                                "Kabul,Afghanistan",
                                "Astana,Kazakhstan; Karachi,Pakistan; Male,Maldives; Yekaterinburg,Russia",
                                "Bengaluru,India; Colombo,Sri Lanka; Mumbai,India; New Delhi,India",
                                "Kathmandu,Nepal","Bishkek,Kyrgyzstan; Dhaka,Bangladesh; Omsk,Russia",
                                "Yangon,Myanmar",
                                "Bangkok,Thailand; Hanoi,Vietnam; Jakarta,Indonesia; Novosibirsk,Russia",
                                "Beijing,China; Manila,Philippines; Perth,Australia; Singapore",
                                "Ecula,Australia",
                                "Ngerulmud,Palau; Seoul,Korea; Tokyo,Japan; Yakutsk,Russia",
                                "Adelaide,Australia; Alice Springs,Australia; Darwin,Australia",
                                "Port Moresby,Papua New Guinea; Sydney,Australia; Vladivostok,Russia",
                                "Hoinara,Solomon Islands; Magadan,Russia; Port Vila,Vanuatu",
                                "Nauru; Suva,Fiji; Wake Island,US Minor Outlying Islands; Funafuti,Tuvalu",
                                "Apia,Samoa; Fakaofo,Tokelau; Nuku’alofa,Tonga","Kiritimati,Kiribati",
                                "Baker Island,US Minority Outlying Islands",
                                "Alofi,Niue; Midway,US Minority Outlying Islands",
                                "Honolulu,Hawaii; Papeete,French Polynesia","Adak,Alaska",
                                "Adamstown,Pitcairn Islands; Anchorage,Alaska",
                                "Hermosillo,Mexico; Los Angeles,USA; Phoenix,USA; Vancouver,Canada",
                                "Denver,USA; Easter Island,Chile; Edmonton,Canada Mexico City,Mexico",
                                "Bogota,Colombia; Houston,USA; Minneapolis,USA; Panama",
                                "Caracas,Venezuela; La Paz,Bolivia; New York City,USA; Toronto,Canada",
                                "Buenos Aires,Argentina; Halifax,Canada; Rio de Janeiro,Brazil",
                                "St.John’s,Canada","King Edward Point","Nuuk,Greenland; Praia,Cape Verde",
                                "Accra,Ghana; Dakar,Senegal; Jamestown,Saint Helena; Reykjavik,Iceland",
                                "Casablanca,Morocco; Lagos,Nigeria; Lisbon,Portugal; Londong,UK",
                                "Cairo,Egypt; Copenhagen,Denmark; Johannesburg,South Africa; Rome,Italy",
                                "Addis Ababa,Ethiopia; Bucharest,Romania; Moscow,Russia; Riyadh,Saudi Arabia",
                                "Tehran,Iran",
                                "Abu Dhabi,UAE; Samara,Russia; Victoria,Seychelles; Yerevan,Armenia",
                                "Kabul,Afghanistan",
                                "Astana,Kazakhstan; Karachi,Pakistan; Male,Maldives; Yekaterinburg,Russia",
                                "Bengaluru,India; Colombo,Sri Lanka; Mumbai,India; New Delhi,India",
                                "Kathmandu,Nepal","Bishkek,Kyrgyzstan; Dhaka,Bangladesh; Omsk,Russia",
                                "Yangon,Myanmar",
                                "Bangkok,Thailand; Hanoi,Vietnam; Jakarta,Indonesia; Novosibirsk,Russia",
                                "Beijing,China; Manila,Philippines; Perth,Australia; Singapore",
                                "Ecula,Australia","Ngerulmud,Palau; Seoul,Korea; Tokyo,Japan; Yakutsk,Russia",
                                "Adelaide,Australia; Alice Springs,Australia; Darwin,Australia",
                                "Port Moresby,Papua New Guinea; Sydney,Australia; Vladivostok,Russia",
                                "Hoinara,Solomon Islands; Magadan,Russia; Port Vila,Vanuatu",
                                "Nauru; Suva,Fiji; Wake Island,US Minor Outlying Islands; Funafuti,Tuvalu",
                                "Apia,Samoa; Fakaofo,Tokelau; Nuku’alofa,Tonga","Kiritimati,Kiribati"]);
    
    const timezoneNames = ref(["UTC-12 / AoE","UTC-11 / NUT","UTC-10 / HST / CKT",
                               "UTC-9 / AKST","UTC-8 / PST","UTC-7 / MST","UTC-6 / EAST / CST",
                               "UTC-5 / EST / COT","UTC-4 / AST / CLT","UTC-3:30 / NST",
                               "UTC-3 / ART / BRT","UTC-2 / GST / WGT","UTC-1 / CVT",
                               "UTC / GMT / BST","UTC+1 / CET / WAT","UTC+2 / EET / CAT",
                               "UTC+3 / EAT / AST","UTC+3:30 / IRST","UTC+4 / GST / AMT",
                               "UTC+4:30 / AFT","UTC+5 / MVT / PKT","UTC+5:30 / IST",
                               "UTC+5:45 / NTP","UTC+6 / BST / KGT","UTC+6:30 / MMT",
                               "UTC+7 / ICT / WIB","UTC+8 / AWST / CST",
                               "UTC+8:45 / ACWST","UTC+9 / KST / JST","UTC+9:30 / ACST",
                               "UTC+10 / PGT / AEST","UTC+11 / VUT / SBT",
                               "UTC+12 / WAKT / FJT","UTC+13 / WST / TOT","UTC+14 / LINT",
                               "UTC-12 / AoE","UTC-11 / NUT","UTC-10 / HST / CKT",
                               "UTC-9 / HDT","UTC-8 / AKDT / PST","UTC-7 / PDT / MST",
                               "UTC-6 / CST / MDT","UTC-5 / CDT / EST","UTC-4 / EDT / VET",
                               "UTC-3 / ADT / BRT","UTC-2:30 / NDT","UTC-2 / GST",
                               "UTC-1 / CVT / WGST","UTC / GMT","UTC+1 / WEST / WAT",
                               "UTC+2 / CEST / CAT","UTC+3 / EEST / EAT",
                               "UTC+3:30 / IRST","UTC+4 / GST / AMT",
                               "UTC+4:30 / AFT","UTC+5 / MVT / PKT","UTC+5:30 / IST",
                               "UTC+5:45 / NTP","UTC+6 / BST / KGT","UTC+6:30 / MMT",
                               "UTC+7 / ICT / WIB","UTC+8 / AWST / CST",
                               "UTC+8:45 / ACWST","UTC+9 / KST / JST","UTC+9:30 / ACST",
                               "UTC+10 / PGT / AEST","UTC+11 / VUT / SBT",
                               "UTC+12 / WAKT / FJT","UTC+13 / WST / TOT","UTC+14 / LINT"]);

    const offsetsFromWesternmost = ref([{hour:0,min:0},{hour:1,min:0},{hour:2,min:0},{hour:3,min:0},
                                        {hour:4,min:0},{hour:5,min:0},{hour:6,min:0},{hour:7,min:0},
                                        {hour:8,min:0},{hour:8,min:30},{hour:9,min:0},{hour:10,min:0},
                                        {hour:11,min:0},{hour:12,min:0},{hour:13,min:0},{hour:14,min:0},
                                        {hour:15,min:0},{hour:15,min:30},{hour:16,min:0},{hour:16,min:30},
                                        {hour:17,min:0},{hour:17,min:30},{hour:17,min:45},{hour:18,min:0},
                                        {hour:18,min:30},{hour:19,min:0},{hour:20,min:0},{hour:20,min:45},
                                        {hour:21,min:0},{hour:21,min:30},{hour:22,min:0},{hour:23,min:0},
                                        {hour:24,min:0},{hour:25,min:0},{hour:26,min:0},
                                        {hour:0,min:0},{hour:1,min:0},{hour:2,min:0},{hour:3,min:0},
                                        {hour:4,min:0},{hour:5,min:0},{hour:6,min:0},{hour:7,min:0},
                                        {hour:8,min:0},{hour:9,min:0},{hour:9,min:30},{hour:10,min:0},
                                        {hour:11,min:0},{hour:12,min:0},{hour:13,min:0},{hour:14,min:0},
                                        {hour:15,min:0},{hour:15,min:30},{hour:16,min:0},{hour:16,min:30},
                                        {hour:17,min:0},{hour:17,min:30},{hour:17,min:45},{hour:18,min:0},
                                        {hour:18,min:30},{hour:19,min:0},{hour:20,min:0},{hour:20,min:45},
                                        {hour:21,min:0},{hour:21,min:30},{hour:22,min:0},{hour:23,min:0},
                                        {hour:24,min:0},{hour:25,min:0},{hour:26,min:0}]);

    onMounted(() => 
    {
        const timezoneFromTemp = ref(0);
        if(!isDSTOn())
        {
            switch(timeOfDay.value.getTimezoneOffset())
            {
                case 720:
                {
                    timezoneFromTemp.value = 0;
                    break;
                }

                case 660:
                {
                    timezoneFromTemp.value = 1;
                    break;
                }

                case 600:
                {
                    timezoneFromTemp.value = 2;
                    break;
                }

                case 540:
                {
                    timezoneFromTemp.value = 3;
                    break;
                }

                case 480:
                {
                    timezoneFromTemp.value = 4;
                    break;
                }

                case 420:
                {
                    timezoneFromTemp.value = 5;
                    break;
                }

                case 360:
                {
                    timezoneFromTemp.value = 6;
                    break;
                }

                case 300:
                {
                    timezoneFromTemp.value = 7;
                    break;
                }

                case 240:
                {
                    timezoneFromTemp.value = 8;
                    break;
                }

                case 210:
                {
                    timezoneFromTemp.value = 9;
                    break;
                }

                case 180:
                {
                    timezoneFromTemp.value = 10;
                    break;
                }

                case 120:
                {
                    timezoneFromTemp.value = 11;
                    break;
                }

                case 60:
                {
                    timezoneFromTemp.value = 12;
                    break;
                }

                case 0:
                {
                    timezoneFromTemp.value = 13;
                    break;
                }

                case -60:
                {
                    timezoneFromTemp.value = 14;
                    break;
                }

                case -120:
                {
                    timezoneFromTemp.value = 15;
                    break;
                }

                case -180:
                {
                    timezoneFromTemp.value = 16;
                    break;
                }

                case -210:
                {
                    timezoneFromTemp.value = 17;
                    break;
                }

                case -240:
                {
                    timezoneFromTemp.value = 18;
                    break;
                }

                case -270:
                {
                    timezoneFromTemp.value = 19;
                    break;
                }

                case -300:
                {
                    timezoneFromTemp.value = 20;
                    break;
                }

                case -330:
                {
                    timezoneFromTemp.value = 21;
                    break;
                }

                case -345:
                {
                    timezoneFromTemp.value = 22;
                    break;
                }

                case -360:
                {
                    timezoneFromTemp.value = 23;
                    break;
                }

                case -390:
                {
                    timezoneFromTemp.value = 24;
                    break;
                }

                case -420:
                {
                    timezoneFromTemp.value = 25;
                    break;
                }

                case -480:
                {
                    timezoneFromTemp.value = 26;
                    break;
                }

                case -525:
                {
                    timezoneFromTemp.value = 27;
                    break;
                }

                case -540:
                {
                    timezoneFromTemp.value = 28;
                    break;
                }

                case -570:
                {
                    timezoneFromTemp.value = 29;
                    break;
                }

                case -600:
                {
                    timezoneFromTemp.value = 30;
                    break;
                }

                case -660:
                {
                    timezoneFromTemp.value = 31;
                    break;
                }

                case -720:
                {
                    timezoneFromTemp.value = 32;
                    break;
                }

                case -780:
                {
                    timezoneFromTemp.value = 33;
                    break;
                }

                case -840:
                {
                    timezoneFromTemp.value = 34;
                    break;
                }
            }
        }

        else
        {
            switch(timeOfDay.value.getTimezoneOffset())
            {
                case 720:
                {
                    timezoneFromTemp.value = 35;
                    break;
                }

                case 660:
                {
                    timezoneFromTemp.value = 36;
                    break;
                }

                case 600:
                {
                    timezoneFromTemp.value = 37;
                    break;
                }

                case 540:
                {
                    timezoneFromTemp.value = 38;
                    break;
                }

                case 480:
                {
                    timezoneFromTemp.value = 39;
                    break;
                }

                case 420:
                {
                    timezoneFromTemp.value = 40;
                    break;
                }

                case 360:
                {
                    timezoneFromTemp.value = 41;
                    break;
                }

                case 300:
                {
                    timezoneFromTemp.value = 42;
                    break;
                }

                case 240:
                {
                    timezoneFromTemp.value = 43;
                    break;
                }

                case 180:
                {
                    timezoneFromTemp.value = 44;
                    break;
                }

                case 150:
                {
                    timezoneFromTemp.value = 45;
                    break;
                }

                case 120:
                {
                    timezoneFromTemp.value = 46;
                    break;
                }

                case 60:
                {
                    timezoneFromTemp.value = 47;
                    break;
                }

                case 0:
                {
                    timezoneFromTemp.value = 48;
                    break;
                }

                case -60:
                {
                    timezoneFromTemp.value = 49;
                    break;
                }

                case -120:
                {
                    timezoneFromTemp.value = 50;
                    break;
                }

                case -180:
                {
                    timezoneFromTemp.value = 51;
                    break;
                }

                case -210:
                {
                    timezoneFromTemp.value = 52;
                    break;
                }

                case -240:
                {
                    timezoneFromTemp.value = 53;
                    break;
                }

                case -270:
                {
                    timezoneFromTemp.value = 54;
                    break;
                }

                case -300:
                {
                    timezoneFromTemp.value = 55;
                    break;
                }

                case -330:
                {
                    timezoneFromTemp.value = 56;
                    break;
                }

                case -345:
                {
                    timezoneFromTemp.value = 57;
                    break;
                }

                case -360:
                {
                    timezoneFromTemp.value = 58;
                    break;
                }

                case -390:
                {
                    timezoneFromTemp.value = 59;
                    break;
                }

                case -420:
                {
                    timezoneFromTemp.value = 60;
                    break;
                }

                case -480:
                {
                    timezoneFromTemp.value = 61;
                    break;
                }

                case -525:
                {
                    timezoneFromTemp.value = 62;
                    break;
                }

                case -540:
                {
                    timezoneFromTemp.value = 63;
                    break;
                }

                case -570:
                {
                    timezoneFromTemp.value = 64;
                    break;
                }

                case -600:
                {
                    timezoneFromTemp.value = 65;
                    break;
                }

                case -660:
                {
                    timezoneFromTemp.value = 66;
                    break;
                }

                case -720:
                {
                    timezoneFromTemp.value = 67;
                    break;
                }

                case -780:
                {
                    timezoneFromTemp.value = 68;
                    break;
                }

                case -840:
                {
                    timezoneFromTemp.value = 69;
                    break;
                }
            }
        }

        emit('set-timezone-index',timezoneFromTemp.value);
    });

    const calculate = () => 
    {
        const timeDiff = computed(() => 
        {
            const from = offsetsFromWesternmost.value[timezoneFromIndex.value];
            const to = offsetsFromWesternmost.value[timezoneToIndex.value];

            let diffHours = to.hour - from.hour;
            let diffMinutes = to.min - from.min;

            if (diffMinutes >= 60) 
            {
                diffHours += Math.floor(diffMinutes / 60);
                diffMinutes = diffMinutes % 60;
            } 

            else if (diffMinutes < 0) 
            {
                diffHours -= 1;
                diffMinutes += 60;
            }

            return { hour: diffHours, min: diffMinutes };
        });

        const convertedTime = computed(() => 
        {
            let baseHour = Number(hour.value);
            let baseMin = Number(min.value);
            let baseSec = Number(sec.value);

            if (!is24Hour.value) 
            {
                if (AMPMToggle.value === 'PM' && baseHour !== 12) baseHour += 12;
                else if (AMPMToggle.value === 'AM' && baseHour === 12) baseHour = 0;
            }

            let h = baseHour + timeDiff.value.hour;
            let m = baseMin + timeDiff.value.min;
            let s = baseSec;

            if (m >= 60) 
            {
                h += Math.floor(m / 60);
                m = m % 60;
            } 
            
            else if (m < 0) 
            {
                h -= Math.ceil(Math.abs(m) / 60);
                m = (60 + (m % 60)) % 60;
            }

            h = ((h % 24) + 24) % 24;

            let displayHour = h;
            let ampm = '';

            if (!is24Hour.value) 
            {
                ampm = h >= 12 ? ' PM' : ' AM';
                displayHour = h % 12;
                displayHour = displayHour === 0 ? 12 : displayHour;
            }

            return {
                hour: displayHour.toString().padStart(2, '0'),
                min: m.toString().padStart(2, '0'),
                sec: s.toString().padStart(2, '0'),
                AMPM: is24Hour.value ? '' : ampm
            };
        });

        resultLbl.value = convertedTime.value.hour + ":" + convertedTime.value.min + ":" + convertedTime.value.sec + convertedTime.value.AMPM;
        formSubmitted.value = true;
    }
</script>

<style scoped>
    main
    {
        grid-area: 2 / 1 / 3 / 2;
        font-family: Syne;
        display:flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width:92%;
        max-width: 600px;
        padding:1.333% 4%;
        margin:14px auto;
        border-radius: 12px;
    }

    main.lightmode
    {
        background-color: #F7F7F6;
        color:#2b3133;
        box-shadow:#2b3133 0px 1px 7px 1px;
        -webkit-box-shadow:#2b3133 0px 1px 7px 1px;
    }

    main.darkmode
    {
        background-color: #2b3133;
        color: #F7F7F6;
        box-shadow:rgb(50, 142, 110) 0px 1px 7px 1px;
        -webkit-box-shadow:rgb(50, 142, 110) 0px 1px 7px 1px;
    }
    
    form
    {
        display: grid;
        grid-template-rows: 0 28px 100px 30px 140px 60px 2fr;
        grid-template-columns: repeat(4,25vw);
    }

    form.lightmode,main.lightmode
    {
        background-color: #F7F7F6;
        color:#2b3133;
    }

    form.darkmode,main.darkmode
    {
        background-color: #2b3133;
        color:#F7F7F6;
    }

    h1
    {
        margin:0;
        justify-self: center;
        cursor:default;
        font-size: x-large;
    }

    label#h24-check
    {
        grid-area: 2 / 2 / 3 / 4;
        justify-self: center;
        font-size: larger;
        cursor:pointer;
    }

    div.time-selection-div
    {
        margin:0;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding:4px;
    }

    div.time-selection-div label
    {
        margin:0;
        width:auto;
        height:auto;
        font-size:20px;
    }

    select
    {
        align-self:stretch;
        width:100%;
        flex-grow: 1;
        font-family: Syne;
        font-size:50px;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 4px;
        border-radius: 6px;
        cursor: pointer;
    }

    select.lightmode
    {
        color:#2b3133;
    }

    select.darkmode
    {
        color:#F7F7F6;
        background-color: #202526;
    }

    div.time-selection-div#hour-select-div
    {
        grid-area: 3 / 1 / 4 / 2;
    }

    div.time-selection-div#minute-select-div
    {
        grid-area: 3 / 2 / 4 / 3;
    }

    div.time-selection-div#second-select-div
    {
        grid-area: 3 / 3 / 4 / 4;
    }

    div.time-selection-div#h24-select-div
    {
        grid-area: 3 / 4 / 4 / 5;
    }

    div.time-selection-div#h24-select-div label
    {
        user-select: none;
        cursor: default;
    }

    div.time-selection-div#h24-select-div label.lightmode
    {
        color:#F7F7F6;
    }

    div.time-selection-div#h24-select-div label.darkmode
    {
        color:#2b3133;
    }

    p
    {
        font-size: x-large;
        margin:0;
    }

    p#from-lbl
    {
        grid-area: 4 / 1 / 5 / 3;
        justify-self: right;
        padding-right: 5px;
    }

    p#to-lbl
    {
        grid-area: 4 / 3 / 5 / -1;
        padding-left: 5px;
    }

    div.timezone-selection
    {
        width:95%;
        height:90%;
        font-family: Syne;
        border:1px solid #2b3133;
        border-radius: 6px;
        justify-self: center;
        align-self: center;
        display: flex;
        flex-direction: column;
        user-select: none;
        cursor: pointer;
    }

    div.timezone-selection.lightmode
    {
        background-color: white;
        color:#2b3133;
    }

    div.timezone-selection.darkmode
    {
        background-color: #202526;
        color:#F7F7F6;
    }

    div.timezone-selection#from-select
    {
        grid-area: 5 / 1 / 6 / 3;
    }

    div.timezone-selection#to-select
    {
        grid-area: 5 / 3 / 6 / -1;
    }

    p.timezone-cities
    {
        height:80%;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: larger;
    }

    p.timezone-names
    {
        height:20%;
        font-size: larger;
        font-weight: bolder;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    button
    {
        grid-area: 6 / 2 / 7 / 4;
        font-family: Syne;
        font-size: 40px;
        border-radius:8px;
        border:none;
        padding:4px;
        cursor:pointer;
    }

    button:hover
    {
        text-decoration: underline;
    }

    button.lightmode
    {
        background-color: #1DCD9F;
        color:#F7F7F6;
    }

    button.darkmode
    {
        background-color: #328E6E;
        color:#F7F7F6;
    }

    fieldset
    {
        grid-area: 7 / 1 / -1 / -1;
        height:100px;
        border-radius: 8px;
    }

    output
    {
        font-family: Syne;
        font-size:clamp(30px,12vw,60px);
        font-weight: bolder;
        margin:auto 4vw;
    }

    output.not-submitted
    {
        user-select: none;
    }

    output.not-submitted.lightmode,output.darkmode
    {
        color:#F7F7F6;
    }

    output.not-submitted.darkmode,output.lightmode
    {
        color:#2b3133;
    }

    @media (max-width:360px)
    {
        form
        {
            grid-template-rows: 0px 28px 1fr 30px 140px 1fr 2fr;
        }
        p.timezone-cities
        {
            font-size:medium;
        }

        select
        {
            font-size:35px;
        }

        div.time-selection-div label
        {
            font-size: 14px;
        }
    }

    @media (max-width:340px)
    {
        p.timezone-names
        {
            font-size:medium;
        }

        button
        {
            font-size: 25px;
            width:auto;
            justify-self: center;
        }
        
        form
        {
            grid-template-rows: 0px 28px 1fr 30px 140px 40px 2fr;
        }

        output
        {
            font-size:clamp(30px,12vw,60px);
            margin:0 2vw;
        }
    }

    @media (max-width:300px)
    {
        p.timezone-names,p.timezone-cities
        {
            font-size:14px;
        }

        h1
        {
            font-size:large;
        }

        form
        {
            grid-template-rows: 0px 20px 1fr 30px 140px 40px 2fr;
        }
    }

    @media (min-width:400px)
    {
        button
        {
            width:200px;
            justify-self: center;
        }
    }

    @media (min-width:700px)
    {
        form
        {
            grid-template-columns: repeat(4,130px);
            justify-self: center;
        }
    }
</style>